/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ILoginSlice {
  loginPhone: string;
  isGetProfile: boolean;
}

const initialState: ILoginSlice = {
  loginPhone: '',
  isGetProfile: true
};

export const registerSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLoginPhone: (state: ILoginSlice, action: PayloadAction<string>) => {
      const { payload } = action;
      state.loginPhone = payload;
    },
    setIsGetProfile: (state: ILoginSlice, action: PayloadAction<boolean>) => {
      const { payload } = action;
      state.isGetProfile = payload;
    }
  }
});

const { actions, reducer } = registerSlice;
export const { setLoginPhone, setIsGetProfile } = actions;
export default reducer;
